var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFailedIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2808_4542)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_2808_4542)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.375 10.1875C19.375 15.5378 15.0378 19.875 9.6875 19.875C4.33723 19.875 0 15.5378 0 10.1875C0 4.83723 4.33723 0.5 9.6875 0.5C15.0378 0.5 19.375 4.83723 19.375 10.1875ZM8.56695 15.317L15.7545 8.12945C15.9985 7.88539 15.9985 7.48965 15.7545 7.24559L14.8706 6.36172C14.6265 6.11762 14.2308 6.11762 13.9867 6.36172L8.125 12.2234L5.38832 9.48668C5.14426 9.24262 4.74852 9.24262 4.50441 9.48668L3.62055 10.3705C3.37648 10.6146 3.37648 11.0104 3.62055 11.2544L7.68305 15.3169C7.92715 15.561 8.32285 15.561 8.56695 15.317Z",
  fill: "#099268"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2808_4542"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(0 0.5)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_2808_4542"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(0 0.5)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFailedIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "e9b52d714ba57f307cf4da828cee357c.svg";